import React, { Dispatch, FC, memo, SetStateAction } from "react";
import { useLocation } from "react-router-dom";
import {
  SecondaryNavBarItems,
  SecondaryNavigationBarStyled,
  SecondaryNavItemStyled,
  SecondaryNavTitleStyled,
} from "./styles";
import { useFlags } from "launchdarkly-react-client-sdk";

interface SecondaryLinkItemType {
  id: string;
  text: string;
  link: string;
}

const STATION_VIEW_ID = "stationview";

const linksConfig: Array<SecondaryLinkItemType> = [
  {
    id: "operator",
    text: "Operator View",
    link: "/operator",
  },
  {
    id: STATION_VIEW_ID,
    text: "Station",
    link: "/station",
  },
  {
    id: "intersections",
    text: "Intersection",
    link: "/intersections",
  },
];

export const SecondaryNavBarMap: FC<{
  isSecondaryNavMapShown: boolean;
  setIsSecondaryNavMapShown: Dispatch<SetStateAction<boolean>>;
}> = memo(({ isSecondaryNavMapShown, setIsSecondaryNavMapShown }) => {
  const { pathname } = useLocation();
  const { featureFlagStationView } = useFlags();

  const filteredLinks = linksConfig.filter(
    (link) => link.id !== STATION_VIEW_ID || featureFlagStationView
  );

  return (
    <SecondaryNavigationBarStyled
      isShown={isSecondaryNavMapShown}
      onMouseEnter={() => {
        setIsSecondaryNavMapShown(true);
      }}
      onMouseLeave={() => {
        setIsSecondaryNavMapShown(false);
      }}
    >
      <SecondaryNavBarItems>
        {filteredLinks.map(({ id, link, text }) => (
          <SecondaryNavItemStyled
            key={id}
            to={link}
            active={pathname === link}
            onClick={() => {
              setIsSecondaryNavMapShown(false);
            }}
          >
            <SecondaryNavTitleStyled>{text}</SecondaryNavTitleStyled>
          </SecondaryNavItemStyled>
        ))}
      </SecondaryNavBarItems>
    </SecondaryNavigationBarStyled>
  );
});
